export const ProjectManagementSvg = ({ props, active }) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.324 10.977v2.047a2.814 2.814 0 002.814 2.814h2.047a2.814 2.814 0 002.814-2.814v-2.047a2.814 2.814 0 00-2.814-2.814h-2.047a2.814 2.814 0 00-2.814 2.814zm1.535 0c0-.706.573-1.279 1.28-1.279h2.046c.706 0 1.279.573 1.279 1.28v2.046a1.28 1.28 0 01-1.28 1.279h-2.046a1.28 1.28 0 01-1.279-1.28v-2.046zM1 3.814v2.047a2.814 2.814 0 002.814 2.814h2.047A2.814 2.814 0 008.675 5.86V3.814A2.814 2.814 0 005.86 1H3.814A2.814 2.814 0 001 3.814zm1.535 0c0-.706.573-1.28 1.279-1.28h2.047c.706 0 1.279.574 1.279 1.28v2.047A1.28 1.28 0 015.86 7.14H3.815a1.28 1.28 0 01-1.28-1.28V3.815zM1 18.14v2.046A2.814 2.814 0 003.814 23h2.047a2.814 2.814 0 002.814-2.814v-2.047a2.814 2.814 0 00-2.814-2.814H3.814A2.814 2.814 0 001 18.14zm1.535 0c0-.707.573-1.28 1.279-1.28h2.047c.706 0 1.279.573 1.279 1.28v2.046a1.28 1.28 0 01-1.28 1.279H3.815a1.28 1.28 0 01-1.28-1.28V18.14z"
        fill={active ? '#FF6A00' : '#fff'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.796 16.86h.04l.033-.004c.147-.02.734-.145.734-.776v-1.01a2.302 2.302 0 012.303-2.303h8.186a.768.768 0 000-1.535H7.906a3.84 3.84 0 00-3.838 3.838v1.023a.71.71 0 00.017.155.766.766 0 00.711.61zM19.124 9.697l.04.001.033-.004c.147-.02.735-.145.735-.776v-1.01a3.84 3.84 0 00-3.838-3.838H7.908a.768.768 0 000 1.535h8.186a2.302 2.302 0 012.303 2.303V8.93c0 .053.005.105.016.155.02.11.061.2.115.274a.766.766 0 00.596.337zM7.908 19.93h7.163a.768.768 0 00.542-1.31l-2.046-2.047a.767.767 0 10-1.085 1.085l.736.737h-5.31a.768.768 0 000 1.535z"
        fill={active ? '#FF6A00' : '#fff'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.527 18.62l-2.046 2.047a.767.767 0 101.084 1.085l2.047-2.047a.766.766 0 10-1.085-1.085z"
        fill={active ? '#FF6A00' : '#fff'}
      />
    </svg>
  );
};
